module.exports = __webpack_public_path__ + "static/media/RamLogo.e801e3ad.png";